export default {
    income: {
        labels: ['1 Mar', '2 Mar', '3 Mar', '4 Mar', '5 Mar'],
        curve: 'smooth', // straight, smooth, & stepline
        data: [30, 80, 50, 80, 90]
    },
    order: {
        labels: ['1 Mar', '2 Mar', '3 Mar', '4 Mar', '5 Mar'],
        curve: 'smooth', // straight, smooth, & stepline
        data: [2000, 1300, 2000, 1500, 2000]
    },
    newUser: {
        labels: ['1 Mar', '2 Mar', '3 Mar', '4 Mar', '5 Mar'],
        curve: 'straight', // straight, smooth, & stepline
        data: [100, 300, 100, 300, 300]
    },
    user: {
        labels: ['1 Mar', '2 Mar', '3 Mar', '4 Mar', '5 Mar'],
        curve: 'stepline', // straight, smooth, & stepline
        data: [6000, 7000, 8000, 9000, 10000]
    },
}